export const initializeSegment = () => {
  if (!import.meta.env.VITE_APP_ANALYTICS_KEY || import.meta.env.VITE_APP_ANALYTICS_KEY === '') return;
  if (typeof window === 'undefined' || !window.analytics) return;

  window.analytics.load(import.meta.env.VITE_APP_ANALYTICS_KEY);
  window.analytics.page();
};

export const identify = (email: string) => {
  if (typeof window === 'undefined' || !window.analytics) return;

  window.analytics.identify(email);
};

export const track = (event: string, payload?: Record<string, unknown>) => {
  if (import.meta.env.VITE_APP_ANALYTICS_KEY === '') return;
  if (typeof window === 'undefined' || !window.analytics) return;

  window.analytics.track(event, payload);
};

export const trackWithCallback = (
  event: string,
  payload?: Record<string, unknown>,
  callback?: (() => void) | undefined,
) => {
  if (typeof window === 'undefined' || !window.analytics) return;

  if (callback) window.analytics.track(event, payload, callback);
  else track(event, payload);
};
